export default __webpack_public_path__ + "static/media/25_2_1.e23d13b7.png";